/*
 * Created by Anup Shrestha (anup.stha012@gmail.com)
 * Copyright (c) 2022.  All rights reserved.
 * Last modified 5/12/22, 10:36 AM
 *
 */

import { useQuery } from 'react-query';

import { getInvoiceList } from 'features/members/api/requests/member.request';

export const useInvoiceHistory = (memberId: number, invoice_id?: number) => {
  return useQuery(['invoice-list', memberId], () => getInvoiceList(memberId), {
    enabled: !!invoice_id,
    staleTime: Infinity,
  });
};
